import { Link } from '@/i18n/navigation'

import { useTranslations } from 'next-intl'

import { NABADOMAIN } from '@/config/constants'

import Flex from '@/components/atoms/Flex'
import Icon from '@/components/atoms/Icon'
import Container from '@/components/atoms/Container'
import { ButtonLabel, Paragraph } from '@/components/atoms/Typography'

import styles from './Header.module.scss'
const PreHeader = () => {
  const t = useTranslations('Header')

  return (
    <div className={styles.preHeader}>
      <Container>
        <Flex
          justifyContent='between'
          alignItems='center'
        >
          <Link
            className={styles.goToMain}
            href={NABADOMAIN}
            target='_blank'
          >
            <ButtonLabel
              size='sm'
              weight='medium'
            >
              <Flex
                gap='0.5rem'
                alignItems='center'
              >
                <Icon iconName='ArrowLeft' />
                {t('preHeader.goToMain')}
              </Flex>
            </ButtonLabel>
          </Link>
          <Paragraph
            size='xs'
            className={styles.ranking}
          >
            {t('preHeader.ranking')}
          </Paragraph>
        </Flex>
      </Container>
    </div>
  )
}

export default PreHeader
